import { useState } from 'react'
import { Smartphone } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { desktop } from '@/lib/printTransport'
import { bridgePrintTest } from '@/lib/bhooklyAppPrint'

/**
 * Phone/PWA setup for the Bhookly Android print agent.
 * Multi-printer: each station's printer target (ip:port) is sent in one Intent.
 */
export function BridgePrintSetting() {
  const isDesktop = !!desktop()
  const [msg, setMsg] = useState<string | null>(null)

  if (isDesktop) return null

  const onTest = () => {
    const ok = bridgePrintTest()
    setMsg(
      ok
        ? 'Sent to Android default printer — you should see a “Printing…” toast. First time: Bhookly → Always. Per-station routing uses Admin → Stations → printer target (ip:port).'
        : 'Could not open the Android intent — is the Bhookly app installed on THIS phone?',
    )
  }

  return (
    <div className="rounded-lg border border-border p-4">
      <div className="flex items-start justify-between gap-3">
        <label className="text-sm font-medium text-foreground flex items-center gap-2">
          <Smartphone className="w-4 h-4" /> Bhookly print agent (phone KOT)
        </label>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        Install the <strong>Bhookly</strong> Android app on this phone. Set each kitchen station&apos;s{' '}
        <strong>printer target</strong> to its LAN address (e.g. Kitchen{' '}
        <code>192.168.18.10:9100</code>, Rooftop <code>192.168.18.20:9100</code>) under Admin →
        Stations. After Fire KOT, tap <strong>Print</strong> — one Intent sends every slip to the
        right printer. This test button uses the agent&apos;s default IP only.
      </p>
      {msg && <p className="text-xs mt-2 text-foreground">{msg}</p>}
      <div className="flex flex-wrap gap-2 mt-3">
        <Button type="button" variant="outline" size="sm" onClick={onTest}>
          Print test slip
        </Button>
      </div>
    </div>
  )
}
